import Dinero from 'dinero.js';
import { roundCurrency, roundDollarsToCents } from "./bankersRound";

export function formatDate(date, format_pattern = 'MMMM DD, YYYY') {
  return date.format(format_pattern);
}

export function currency(amount, showSymbol = true, format = '$0,0.00') {
  if (isNaN(amount)) return false;
  let currencyFormat = format;
  const dineroReady = { amount: parseInt(roundCurrency(amount), 10) };

  if (!showSymbol) currencyFormat = format.slice(1);
  return Dinero(dineroReady).toFormat(currencyFormat);
}
